export default __webpack_public_path__ + "static/trailBazarLogo-f5f70476e7e8a8a27c1473eff9ab6ab4.png";